/** @format */

import { DOCUMENT } from '@angular/common';
import { Component, Inject, Input, OnInit } from '@angular/core';

@Component({
	selector: 'clp-searchdex',
	templateUrl: './searchdex.component.html',
	styleUrl: './searchdex.component.scss',
	standalone: false
})
export class SearchdexComponent implements OnInit {
	@Input() data: any;

	tabs = [];
	seoHeadline;
	featuredLinks: { target: string; text: string }[] = [];

	constructor(@Inject(DOCUMENT) private document: HTMLDocument) {}

	ngOnInit() {
		if (this.data && this.data.attr) {
			this.compileSEOTabs(this.data.attr);
			this.parseFeaturedLinks(this.data.attr);
		}
	}

	compileSEOTabs(seoDataAttr: any) {
		for (let i = 1; i < 5; i++) {
			const tabString = `SEO_TAB${i}`;
			if (
				typeof seoDataAttr[`${tabString}_CONTENT`] !== 'undefined' &&
				seoDataAttr[`${tabString}_CONTENT`].value
			) {
				const heading = seoDataAttr[`${tabString}_HEADING`]
					? seoDataAttr[`${tabString}_HEADING`].value
					: seoDataAttr[`SEO_HEADLINE`]
						? seoDataAttr[`SEO_HEADLINE`].value
						: '';
				this.tabs.push({
					heading,
					content: this.trimHeadingOutOfSEOTabContent(
						seoDataAttr[`${tabString}_CONTENT`].value
					)
				});
			}
		}

		if (this.tabs.length > 0 && seoDataAttr.SEO_HEADLINE) {
			this.seoHeadline = seoDataAttr.SEO_HEADLINE.value;
		}
	}

	trimHeadingOutOfSEOTabContent(content: any) {
		const newEl = this.document.createElement('div');
		newEl.innerHTML = content;
		const h3El = newEl.getElementsByTagName('h3');
		if (h3El.length > 0) {
			h3El.item(0).remove();
		}
		return newEl.innerHTML.replace(/�/g, '');
	}

	parseFeaturedLinks(attr) {
		if (attr.SEO_FEATURED_LINKS) {
			const links = JSON.parse(attr.SEO_FEATURED_LINKS.value);
			const linkKeys = Object.keys(links);
			for (const l in linkKeys) {
				const lKey = linkKeys[l];
				this.featuredLinks.push({ text: lKey, target: links[lKey] });
			}
		}
	}

	trackByTarget(index: number, item: { target: string }): string {
		return index.toString() + item.target;
	}
}
